import { runWhenBootLoaderIsDrawing } from "./loader/bootGate";
import { getLoaderWorker } from "./loader/loaderWorkerClient";

// The entry is deliberately tiny. The app itself (./bootstrap: the store, the router, every screen) is the part that blocks the main thread for a long time when it is first evaluated, and
// while it runs nothing else can START - including the loading animation's worker. So this file only makes sure that worker exists and is drawing, and THEN requires the app. `require` (not
// `import`) because an import is evaluated before this file's own code runs, which is exactly what must not happen first; and it stays in this one bundle, so main.*.js still holds the
// whole app. See src/loader/bootGate.ts for the measurement.
getLoaderWorker();
runWhenBootLoaderIsDrawing(() => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require("./bootstrap");
});
